import React, { useEffect } from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { generateId, shortHandDate } from '../../../utility/functions';
import Table from '../../../table/Table';
import Col from '../../../layout/Col';
import Row from '../../../layout/Row';

const Referral = ({ ...props }) => {
    const tableConfig = {
        endpoint: QuestRoute.reports.referral,
        reportCallback: (res, set) => {
            res.forEach(e => {
                e.items = e.washClubs.map(f => `${shortHandDate(f.logTimeUtc)}-${f.name}`).join(', ')
            })
            set(res)
        },
        isReport: true,
        headers: [
            {
                label: 'User',
                propKey: 'email',
            }, {
                label: 'Sign Ups',
                propKey: 'signupCount',
                sortBy: true,
                ascending: false
            }, {
                label: 'Items',
                propKey: 'items',
            },
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{e.email}</td>
                <td>{e.signupCount}</td>
                <td>
                    <Col>
                        {e.washClubs
                            .filter(washClub => !window.TableFilter.length || window.TableFilter.some(({ key, query }) => key === 'items' && washClub.name.toLowerCase().includes(query.toLowerCase())))
                            .map((washClub, i) => (
                                <Row key={'WashClubItems-' + i}>
                                    <span style={{ flex: 1 }}>{shortHandDate(washClub.logTimeUtc)}</span>
                                    <span style={{ flex: 1 }}>{washClub.name}</span>
                                </Row>
                            ))
                        }
                    </Col>
                </td>
            </tr>
        )
    }

    return (
        <Table config={tableConfig} />
    );
}

export default Referral;